import Swiper from 'swiper/bundle';

document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.related-tours-swiper' ).forEach( ( el ) => {
		const slider = el.closest( '.related-tours__slider' );
		new Swiper( el, {
			slidesPerView: 1.2,
			spaceBetween: 16,
			breakpoints: {
				640: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				},
				1280: {
					slidesPerView: 3.5,
				},
			},
			navigation: {
				nextEl: slider.querySelector( '.related-tours__next' ),
				prevEl: slider.querySelector( '.related-tours__prev' ),
			},
		} );
	} );
} );
